import React from 'react'
import { CustomerStoryStat } from '../../api/Types'

interface Props {
  customerStoryStat: CustomerStoryStat
}

const iconUp = (
  <svg width='27' height='24' viewBox='0 0 27 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M1.75288 22.8028L7.76328 12.3925L14.4994 16.2816L22.6311 2.19699M22.6311 2.19699L13.4548 4.65577M22.6311 2.19699L24.8311 10.4074'
      stroke='#1AC876'
      stroke-width='3'
    />
  </svg>
)

const iconDown = (
  <svg width='24' height='27' viewBox='0 0 24 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0.999935 2.06049L11.4103 8.0709L7.52118 14.807L21.6057 22.9387M21.6057 22.9387L19.147 13.7624M21.6057 22.9387L13.3954 25.1387'
      stroke='#D9534F'
      stroke-width='3'
    />
  </svg>
)

const CustomerStoryStat: React.FC<Props> = ({ customerStoryStat }) => {
  let icon: JSX.Element | null

  switch (customerStoryStat.icon) {
    case 'up':
      icon = iconUp
      break
    case 'down':
      icon = iconDown
      break
    default:
      icon = null
  }

  return (
    <div className='customer-story-stat'>
      {icon}
      <div className='customer-story-stat-description'>{customerStoryStat.description}</div>
    </div>
  )
}

export default CustomerStoryStat
